import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { registerLocale } from 'react-datepicker';
import fi from 'date-fns/locale/fi';
import { convertToRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { setAdValues } from 'Util/trainingUtils';
import {
  Fields,
  ImageArea,
} from 'Components/EducationPage/NewTraining/CommonTrainingCreationProps';
import AddPhotoModal from '../FormComponents/AddPhotoModal';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

registerLocale('fi', fi);
const TextEditor = styled(Editor)``;

const Phase2 = ({
  editorState,
  setEditorState,
  nextForm,
}: {
  editorState: EditorState;
  setEditorState: any;
  nextForm: () => void;
}) => {
  const { t } = useTranslation();

  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const convertEditorData = (currentEditorState: any) => {
    setEditorState(currentEditorState);
    setAdValues(
      'description',
      draftToHtml(convertToRaw(currentEditorState.getCurrentContent())),
    );
  };
  return (
    <>
      {showPhotoModal ? (
        <AddPhotoModal modalToggle={setShowPhotoModal} />
      ) : null}
      <Fields style={{ flexDirection: 'column' }}>
        <div className="rows" style={{ width: '100%' }}>
          <label>
            {t('add-image-to-ad')}{' '}
            <span style={{ color: '#1E1E1E', fontWeight: 500 }}>
              ({t('not-mantadory')}, {t('training-image-size-suggestion')})
            </span>
          </label>
          <ImageArea onClick={() => setShowPhotoModal(true)}>
            <div className="image-placeholder">
              <FontAwesomeIcon
                style={{ width: '100%' }}
                className="fa-5x"
                color="#D6DCE2"
                icon={['far', 'image']}
              />
              <span className="image-tooltip"> {t('add-image-to-ad')} </span>
            </div>
          </ImageArea>
          <label>
            {t('training-demo')} <span>*</span>
          </label>
          <TextEditor
            editorState={editorState}
            onEditorStateChange={(e) => convertEditorData(e)}
            placeholder={t('description')}
            editorClassName="rasfgedg"
            wrapperClassName="rasfasrwgedg"
          />
          <div>
            <div
              className="additional-info"
              style={{ width: '35%', float: 'right' }}
            >
              <button type="button" onClick={nextForm}>
                {t('next')}
              </button>
            </div>
          </div>
        </div>
      </Fields>
    </>
  );
};

export default Phase2;
